import { apiFetch } from "./client";

export function getInsights() {
  return apiFetch("/api/admin/insights");
}

export function getCapacity(weeks = 8) {
  return apiFetch(`/api/admin/capacity?weeks=${weeks}`);
}

export function getProfit() {
  return apiFetch("/api/admin/profit");
}

export function saveCostSettings(model) {
  return apiFetch("/api/admin/costs/settings", { method: "PUT", body: model });
}

export function saveJobCosts(quoteId, costs) {
  return apiFetch(`/api/admin/quotes/${quoteId}/costs`, { method: "PUT", body: costs });
}
